import { Icon } from "../../../../../core/components/atoms/Icon";
import { Typography } from "../../../../../core/components/molecules/Typography";

interface IProgressDoneItems {
  title: string;
  icon: string;
  value: number;
  alignment?: 'left' | 'center' | 'right';
}

const ProgressDoneItems = ({
  title,
  icon,
  value,
  alignment = 'left',
}: IProgressDoneItems) => {
  const formattedValue = value.toString().padStart(2, '0');
  const contentAlignmentClass =
    alignment === 'center'
      ? 'items-center text-center md:items-start md:text-left'
      : alignment === 'right'
        ? 'items-end text-right md:items-start md:text-left'
        : 'items-start text-left';
  const rowAlignmentClass =
    alignment === 'center'
      ? 'justify-center md:justify-start'
      : alignment === 'right'
        ? 'justify-end md:justify-start'
        : 'justify-start';

  return (
    <div className={`flex flex-col ${contentAlignmentClass}`}>
      <Typography size='mini' weight="bold" className="text-mono-color-dark leading-tight"> {title} </Typography>
      <div className={`flex w-full flex-row items-center gap-sm ${rowAlignmentClass}`}>
        <Icon Icon={icon} type="material" className="text-mono-color-lighter text-[16px]" />
        <Typography weight="bold" className="text-brand-color-primary-pure text-lg"> {formattedValue} </Typography>
      </div>
    </div>
  );
};

export default ProgressDoneItems;
